"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "What industrial engraving services does Evermark Industrial Solutions offer?",
  answer: "Evermark Industrial Solutions provides six industrial engraving and marking services: phenolic/acrylic engraving, metal engraving, direct part marking, arc flash labels, custom engraving, and submittal packages."
}, {
  question: "What is the difference between laser engraving and laser marking?",
  answer: "Engraving removes material to cut a legend into the surface (phenolic legend plates, metal nameplates); marking changes the surface without deep removal (direct part marking, 2D data matrix, serialization on metal). Evermark Industrial Solutions provides both, matched to the application."
}, {
  question: "Can Evermark engrave from my CAD file?",
  answer: "Yes — Evermark Industrial Solutions accepts DXF, DWG, AI, PDF, STEP, and SVG files. Customers without a file can send a part list or written spec, and Evermark produces the layout and a proof for approval."
}, {
  question: "Does Evermark provide documentation for engineered projects?",
  answer: "Yes — Evermark Industrial Solutions supplies material data sheets, submittal records, and CSI 3-part specification language for specified projects."
}, {
  question: "What's the typical lead time for industrial engraving?",
  answer: "Lead time depends on material, quantity, and finishing. Evermark Industrial Solutions quotes standard and rush options per job. The standard lead time is typically {{verify: standard lead time}}."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="faq" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`bg-muted/20 rounded-2xl p-6 md:p-10 lg:p-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground tracking-tight">
              Industrial Engraving Services — Common Questions
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-border/50">
                <AccordionTrigger className="font-default text-left text-base md:text-lg font-semibold text-foreground hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}